import type { TutorTaskDetails } from '../../model/tutor-tasks/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface TutorTaskShowApiOptions {
  taskId: number
  onStart?: () => void
  onFinish?: () => void
}

/** `GET /admin-api/tutor-tasks/{task}` — the task plus the discipline's sent file packs. */
export const useTutorTaskShowApi = async (options: TutorTaskShowApiOptions): Promise<TutorTaskDetails | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.tutor-task.data', { task_id: options.taskId })

  options.onStart?.()

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.get<ApiResponse>(url)

    return data.data ?? null
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return null
  } finally {
    options.onFinish?.()
  }
}
